<template>
  <table
    class="table b-table b-table-stacked-xs table-bordered table-sm bg-white text-uppercase"
  >
    <tbody>
    <tr>
      <th colspan="4">
        <h5 class="text-center"><b>Outras Características</b></h5>
      </th>
    </tr>
    <tr>
      <td colspan="4">
        GRUPOS POPULACIONAIS TRADICIONAIS E ESPECÍFICOS (GPTE)
        <b>{{ formatResultArray(parc_mds, $root.arrays.parc_mds) }}</b>
      </td>
    </tr>
    <tr>
      <td colspan="4" >
        A família está em risco de violação de direito?
        <b v-if="item.caracteristicas">{{
            formatResultArray(
                item.caracteristicas.ind_risco_violacao_direito,
                $root.arrays.pergunta
            )
          }}
        </b>
      </td>
    </tr>
    <tr >
      <td>
        A FAMÍLIA É INDÍGENA?
        <b v-if="item.caracteristicas">{{
            formatResultArray(
                item.caracteristicas.familia_indigena,
                $root.arrays.pergunta
              )
            }}
          </b>
        </td>
      </tr>
      <tr>
        <td>
          A FAMÍLIA É INDÍGENA?
          <b v-if="item.caracteristicas">{{
            formatResultArray(
              item.caracteristicas.familia_indigena,
              $root.arrays.pergunta
            )
          }}</b>
      </td>
      <td>
        NOME DO POVO INDÍGENA<b v-if="item.caracteristicas" >{{ item.caracteristicas.nome_povo_indigena }}</b>
      </td>
    </tr>
    <tr>
      <td>
        RESIDE EM RESERVA INDÍGENA
        <b v-if="item.caracteristicas" >{{
            formatResultArray(item.caracteristicas.indigena_reside, $root.arrays.pergunta)
          }}</b>
      </td>
      <td>
        NOME DA RESERVA INDÍGENA<b v-if="item.caracteristicas" >{{ item.caracteristicas.nome_reserva_indigena }}</b>
      </td>
    </tr>
    <tr>
      <td>
        A FAMÍLIA É QUILOMBOLA?
        <b v-if="item.caracteristicas" >{{
            formatResultArray(
              item.caracteristicas.indigena_reside,
              $root.arrays.pergunta
            )
          }}</b>
      </td>
      <td>
        NOME DA COMUNIDADE QUILOMBOLA
        <b v-if="item.caracteristicas" >{{ item.caracteristicas.nome_reserva_indigena }}</b>
      </td>
    </tr>
    <tr>
      <td colspan="4">
        QUANTAS PESSOAS MORAM NO SEU DOMICÍLIO? (NÃO PREENCHER PARA FAMÍLIAS EM SITUAÇÃO
        DE RUA E FAMÍLIAS EM DOMICÍLIO COLETIVO)
        <b v-if="item.caracteristicas" >{{ item.caracteristicas.qtd_pessoas_domicilio_etnia }}</b>
      </td>
    </tr>
    <tr>
      <td colspan="4">
        QUANTAS FAMÍLIAS MORAM NO SEU DOMICÍLIO? (NÃO PREENCHER PARA FAMÍLIAS EM
        SITUAÇÃO DE RUA E FAMÍLIAS EM DOMICÍLIO COLETIVO)
        <b v-if="item.caracteristicas" >{{ item.caracteristicas.qtd_familias_domicilio_etnia }}</b>
      </td>
    </tr>
    <tr>
      <td>
        Há alguma pessoa dessa família internada,em acolhimento institucional ou privada
        de liberdade há 12 meses ou mais?
      </td>
    </tr>
    <tr>
      <td colspan="4">
        QUANTIDADE DE CRIANÇA(S) E ADOLESCENTE(S) (DE 0 A 17 ANOS)
        <b v-if="item.caracteristicas" >{{ item.caracteristicas.qtd_pessoa_inter_0_17 }}</b>
      </td>
    </tr>
    <tr>
      <td colspan="4">
        QUANTIDADE DE JOVEM(NS) E ADULTO(S) (DE 18 A 64 ANOS)
        <b v-if="item.caracteristicas" >{{ item.caracteristicas.qtd_pessoa_inter_18_64 }}</b>
      </td>
    </tr>
    <tr>
      <td colspan="4">
        QUANTIDADE DE PESSOA(S) IDOSA(S) (DE 65 ANOS OU MAIS)
        <b v-if="item.caracteristicas" >{{ item.caracteristicas.qtd_pessoa_inter_65 }}</b>
      </td>
    </tr>
    <tr>
      <td colspan="4">
        FAMÍLIA COM RISCO DE VIOLAÇÃO DE DIREITO  
        <b v-if="item.caracteristicas" >{{ item.caracteristicas.ind_risco_violacao_direito }}</b>
      </td>
    </tr>
    <tr>
      <td>
        Centro de Referência da Assistência Social (CRAS/CREAS) em que os membros da
        família são atendidos quando necessitam.
      </td>
    </tr>
    <tr>
      <td>
        NOME DO CRAS/CREAS <b v-if="item.caracteristicas" >{{ item.caracteristicas.nome_cras_creas }}</b>
      </td>
      <td>
        CÓDIGO DO CRAS/CREAS <b v-if="item.caracteristicas">{{ item.caracteristicas.codigo_cras_creas }}</b>
      </td>
    </tr>
    </tbody>
  </table>
</template>

<script>
export default {
  props: ["item"],
  data() {
    return {
      caracteristicas: {
        familia_indigena: null,
        nome_povo_indigena: null,
        indigena_reside: null,
        nome_reserva_indigena: null,
        familia_quilombola: null,
        nome_comunidade_quilombola: null,
        qtd_pessoas_domicilio_etnia: null,
        qtd_familias_domicilio_etnia: null,
        qtd_pessoa_inter_0_17: null,
        qtd_pessoa_inter_18_64: null,
        qtd_pessoa_inter_65: null,
        nome_cras_creas: null,
        codigo_cras_creas: null,
        nome_estabelecimento_saude: null,
        ind_risco_violacao_direito: null
      },
      parc_mds: [],
    };
  },
  mounted() {
    if (this.item.caracteristicas != null) {
      this.caracteristicas = this.item.caracteristicas;
    }
    if (this.item.programas_servicos) {
      this.parc_mds = JSON.parse(this.item.programas_servicos.parc_mds);
    }
  },
  methods: {
    formatResultArray(campo, array) {
      if (campo != "" || campo != null) {
        if (Array.isArray(campo)) {
          const result = campo.map(
            (elem) => array.find((e) => e.id == elem).value
          );
          return result.join(", ");
        }
        const result = array.filter((e) => e.id == campo);
        if (result.length) {
          return result[0]["value"];
        }
      }
    },
  },
};
</script>

<style lang="scss" scoped></style>
